/**
 * esquery
 *  ## 1.ES를 이용해서 쿼리 API를 정의한다 .
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { EsFailure } from '../model/esFailure';
import { EsGiving } from '../model/esGiving';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EsAnonymousDonorService {

    protected basePath = 'https://bstore-dev-nlb-to-backends-03c7de26a0c53e22.elb.ap-northeast-2.amazonaws.com:9980/esquery/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 익명기증자 날짜,확정일 검색
     * 검색 날짜 형식 e.g) -&gt; 2018-09-12
     * @param gte_give_confirm_date 
     * @param lte_give_confirm_date 
     * @param give_confirm_emp_dept_name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public anonymousDonorGet(gte_give_confirm_date: string, lte_give_confirm_date: string, give_confirm_emp_dept_name?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<EsGiving>>;
    public anonymousDonorGet(gte_give_confirm_date: string, lte_give_confirm_date: string, give_confirm_emp_dept_name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<EsGiving>>>;
    public anonymousDonorGet(gte_give_confirm_date: string, lte_give_confirm_date: string, give_confirm_emp_dept_name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<EsGiving>>>;
    public anonymousDonorGet(gte_give_confirm_date: string, lte_give_confirm_date: string, give_confirm_emp_dept_name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (gte_give_confirm_date === null || gte_give_confirm_date === undefined) {
            throw new Error('Required parameter gte_give_confirm_date was null or undefined when calling anonymousDonorGet.');
        }
        if (lte_give_confirm_date === null || lte_give_confirm_date === undefined) {
            throw new Error('Required parameter lte_give_confirm_date was null or undefined when calling anonymousDonorGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (gte_give_confirm_date !== undefined && gte_give_confirm_date !== null) {
            queryParameters = queryParameters.set('gte_give_confirm_date', <any>gte_give_confirm_date);
        }
        if (lte_give_confirm_date !== undefined && lte_give_confirm_date !== null) {
            queryParameters = queryParameters.set('lte_give_confirm_date', <any>lte_give_confirm_date);
        }
        if (give_confirm_emp_dept_name !== undefined && give_confirm_emp_dept_name !== null) {
            queryParameters = queryParameters.set('give_confirm_emp_dept_name', <any>give_confirm_emp_dept_name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        return this.httpClient.get<Array<EsGiving>>(`${this.basePath}/anonymous_donor`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
